/**
 * Import and define sections pages
 */
import * as homePage from "./home";
import * as requestDemoPage from "./requestDemo";
import * as unsubscribePage from "./unsubscribe"
import * as formPage from "./form"
export const pages = [homePage, requestDemoPage, unsubscribePage, formPage];